import { useQuery } from '@tanstack/react-query';
import React from 'react';
import Loader from '@mui/material/CircularProgress';

const Dashboard = () => {

  // Use the authUser query
  const { data: authUser, isFetching, isError } = useQuery({
    queryKey: ['authUser'],
    staleTime: Infinity,
    cacheTime: 10 * 60 * 1000,
  });

  if (isFetching) {
    return (
      <div className="h-[400px] flex justify-center items-center">
        <Loader sx={() => ({ color: '#4f46e5' })} />
      </div>
    );
  }

  if (isError) {
    return <div className="p-6 text-center text-red-500">Error fetching user data.</div>;
  }

  const registrationStatus = authUser?.registrationStatus;
  console.log(registrationStatus);
  
  const name = `${authUser?.firstName || ''} ${authUser?.middleName || ''} ${authUser?.lastName || ''}`;

  return (
    <div className="p-6 font-sans text-center">
      <h2 className="text-2xl font-medium mb-4">
        Welcome {authUser?.firstName + ' ' + authUser?.lastName || 'Guest'}
      </h2>

      {registrationStatus === "Not registered" ? (
        <p className="mb-4 text-red-500">
          You have not been registered. Please submit your abstract and register at the earliest to avail the early-bird offer. First update your profile to proceed to fee payment and abstract submission.
        </p>
      ): registrationStatus === "Under verification" ? (
        <p className='mb-4 text-green-600'>You have successfully completed all the steps for registration. Your payment is under verification we'll notify you once it is done.</p>
      ): (
        <p className='mb-4 text-green-600'>You have successfully registered for the conference.</p>
      )}


      <div className="flex flex-col items-center mb-6">
        <h3 className="text-xl font-medium mb-2">Registration details</h3>
        <div className="text-base">
          <p>
            <span className="font-medium">Name:</span> {registrationStatus === "Under verification" || registrationStatus === "Registered" ? name : 'N/A'}
          </p>
          <p>
            <span className="font-medium">Registration Number:</span> {authUser?.registrationNumber || 'N/A'}
          </p>
          <p>
            <span className="font-medium">Amount Paid:</span> {authUser?.amountPaid || 'N/A'} [Including taxes]
          </p>
        </div>
      </div>

      <div className="flex justify-center">
        <p className="text-base">
          <span className="font-semibold">Abstract submitted:</span> {authUser?.abstractSubmitted ? 'Yes' : 'No'}
        </p>
      </div>
    </div>
  );
};

export default Dashboard;
